import { useGqlQuery } from '@api/gql/gqlServices'
import {
  Category,
  GetCategoriesDocument,
  GetCategoriesQuery,
  GetCategoryByIdDocument,
  GetCategoryByIdQuery
} from '@generated/generates'
import { useViewer } from '@hooks'

interface Props {
  categoryId?: string
}

const useQuestsCategories = ({ categoryId }: Props) => {
  const { isAuthenticated } = useViewer()
  const { data: categoriesData, isLoading: isCategoriesLoading } = useGqlQuery<GetCategoriesQuery>(
    GetCategoriesDocument,
    {
      isActive: true,
      userCompletion: isAuthenticated
    }
  )

  const featuredCategory = categoriesData?.categories.find((category) => category.isFeatured)
  const questsCategories = categoriesData?.categories.filter((category) => !category.isFeatured)

  const { data: categoryData, isLoading: isCategoryLoading } = useGqlQuery<GetCategoryByIdQuery>(
    GetCategoryByIdDocument,
    {
      categoryId: categoryId,
      userCompletion: isAuthenticated
    },
    {
      enabled: !!categoryId
    }
  )

  return {
    questsCategories: (questsCategories as Category[]) || [],
    isCategoriesLoading,
    featuredCategory,
    categoryById: categoryData?.category,
    isCategoryLoading
  }
}

export default useQuestsCategories
